import { useEffect, useState, useCallback } from "react";
import { Eye, EyeOff, Trash2, Star } from "lucide-react";
import { toast } from "sonner";
import { get, put, del, btnDark, btnLight, Card, fmtDate, Empty, PRODUCT_NAMES } from "./shared";

export const Reviews = ({ onChanged }) => {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => get("/reviews").then(setRows).catch(() => setRows([])), []);
  useEffect(() => { load(); }, [load]);
  const changed = () => { load(); onChanged(); };

  const moderate = async (r, approved) => {
    try { await put(`/reviews/${r.id}`, { approved }); toast.success(approved ? "Avis publié" : "Avis masqué"); changed(); } catch { toast.error("Erreur"); }
  };
  const remove = async (r) => {
    if (!window.confirm("Supprimer définitivement cet avis ?")) return;
    try { await del(`/reviews/${r.id}`); toast.success("Avis supprimé"); changed(); } catch { toast.error("Erreur"); }
  };

  const pending = (rows || []).filter((r) => !r.approved);
  const published = (rows || []).filter((r) => r.approved);
  const Item = ({ r }) => (
    <Card className="p-5" data-testid={`admin-review-${r.id}`}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <span className="inline-flex gap-0.5">{[1, 2, 3, 4, 5].map((i) => <Star key={i} size={13} className={i <= r.rating ? "fill-[#C85A32] text-[#C85A32]" : "text-stone-300"} />)}</span>
          <p className="mt-1 text-sm text-stone-900 font-medium">{r.author} · <span className="font-mono text-xs text-stone-500">{r.user_email}</span></p>
          <p className="text-[10px] font-mono uppercase tracking-wide text-stone-500">{PRODUCT_NAMES[r.product_id] || r.product_id} · {r.verified || r.order_id ? `achat vérifié · commande ${r.order_number}` : "avis visiteur (non vérifié)"}</p>
        </div>
        <span className="text-xs font-mono text-stone-400">{fmtDate(r.created_at, true)}</span>
      </div>
      <p className="mt-3 text-sm text-stone-700 italic leading-relaxed">“{r.text}”</p>
      <div className="mt-4 flex gap-2">
        {r.approved ? <button data-testid={`review-hide-${r.id}`} onClick={() => moderate(r, false)} className={btnLight}><EyeOff size={13} /> Masquer</button>
          : <button data-testid={`review-approve-${r.id}`} onClick={() => moderate(r, true)} className={btnDark}><Eye size={13} /> Publier</button>}
        <button data-testid={`review-delete-${r.id}`} onClick={() => remove(r)} className={`${btnLight} hover:!border-rose-600 hover:!text-rose-700`}><Trash2 size={13} /> Supprimer</button>
      </div>
    </Card>
  );

  if (rows === null) return <Empty>Chargement…</Empty>;
  return (
    <div className="space-y-8" data-testid="admin-reviews">
      <p className="text-sm text-stone-600">Les clients laissent leur avis depuis la page produit (ou leur espace client). Rien n'est publié sans votre validation ; le badge « Achat vérifié » n'apparaît que si l'email correspond à une commande livrée.</p>
      <section>
        <h3 className="text-[11px] font-mono uppercase tracking-[0.3em] text-stone-500 mb-4">À modérer ({pending.length})</h3>
        {pending.length === 0 ? <Empty>Aucun avis en attente.</Empty> : <div className="space-y-3">{pending.map((r) => <Item key={r.id} r={r} />)}</div>}
      </section>
      <section>
        <h3 className="text-[11px] font-mono uppercase tracking-[0.3em] text-stone-500 mb-4">Publiés ({published.length})</h3>
        {published.length === 0 ? <Empty>Aucun avis publié.</Empty> : <div className="space-y-3">{published.map((r) => <Item key={r.id} r={r} />)}</div>}
      </section>
    </div>
  );
};
